import React from 'react';
import { StarDivider } from '../Ornaments';
import { Reveal } from '../Reveal';

export const RealmQuote = ({ quote, art, artRight }) => (
  <section className="rquote" data-testid="realm-quote">
    {art && <img src={art} alt="" className="rquote-art" draggable="false" aria-hidden />}
    {artRight && <img src={artRight} alt="" className="rquote-art rquote-art--right" draggable="false" aria-hidden />}
    <Reveal className="rquote-inner">
      <blockquote className="rquote-text" data-testid="realm-quote-text">
        <span className="rquote-mark" aria-hidden>“</span>
        {quote}
        <span className="rquote-mark rquote-mark--end" aria-hidden>”</span>
      </blockquote>
      <StarDivider className="rquote-rule mt-8" />
    </Reveal>
  </section>
);
